import { useAppDispatch } from "Store/hooks";

import { updateVariable } from "../thunks";

import type { EnvironmentVariableData } from "../thunks";
import type { Variable } from "@packages/client";

export function useUpdateVariable({
  organizationId,
  projectId,
  variable,
  environmentId,
  callback
}: {
  organizationId: string;
  projectId: string;
  variable: Variable;
  environmentId: string;
  callback?: (variable?: Variable) => void;
}) {
  const dispatch = useAppDispatch();

  const isVariable = (variable: any): variable is Variable => "id" in variable;

  return (data: EnvironmentVariableData) =>
    dispatch(
      updateVariable({
        organizationId,
        projectId,
        variable,
        environmentId,
        data
      })
    ).then(({ payload }) => {
      if (isVariable(payload)) {
        callback?.(payload);
      }
    });
}
